import React, { useState } from 'react';
import ExcelImportButtonInventory from '../ExcelImportButton/ExcelImportButtonInventory';
import ExcelImportButtonOrder from '../ExcelImportButton/ExcelImportButtonOrder';
import "./ExcelImportSection.css";

const ExcelImportSection = () => {
  const [inventoryFileName, setInventoryFileName] = useState("");
  const [orderFileName, setOrderFileName] = useState("");

  return (
    <div className="excel-import-button-container">
      <div class = "row-divider">
        <div class = "button-container">
          <p className="container-header">入荷データExcel (荷割情報なし)</p>
          <ExcelImportButtonInventory setFileName={setInventoryFileName}>Import Inventory</ExcelImportButtonInventory>
        </div>
        <a>{inventoryFileName}</a>
      </div>
      <div class = "row-divider"> 
        <div class = "button-container">
          <p className="container-header">予約情報Excel</p>
          <ExcelImportButtonOrder setFileName={setOrderFileName}>Import Inventory</ExcelImportButtonOrder>
        </div>
        <a>{orderFileName}</a>
      </div>
    </div>
  );
};

export default ExcelImportSection;
